import { message } from "antd";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import toast from "react-hot-toast";
import BeatLoader from "react-spinners/BeatLoader";
import link from "../../../../assets/img/admin/link.svg";
import search from "../../../../assets/img/admin/search-zoom-in.svg";
import useFetch from "../../../../hooks/useAxios";
import Button from "../../../shared/Button";
import Input from "../../../shared/Input";
const AdminFastSearchForm = ({apiget}) => {
  const {
    handleSubmit,
    formState: { errors, isValid },
    control,
    reset
  } = useForm({
    defaultValues:{
      title:"",
      link:""
    }
  });

  const [searchData, setsearchData] = useState()
  const apipostSearch = useFetch({
    method: "post",
    url: "api/admin/fast-searches/store",
    noHeader: false,
    trigger: false,
    caller:apiget,
    data:searchData,
argFunc:()=>{
  toast.success('ایتم جدید اضافه شد')
  reset({
    title:"",
    link:""
  })
},
errMessage:(err)=>{
  if(err.response.data.message){
    toast.error("مشکلی در درخواست شما بوجود آمد")
  }

}
    
  });
  const onSubmit = (data)=>{
    setsearchData(data)
    console.log(data)
  }
  useEffect(() => {
    if(searchData){
      apipostSearch.reFetch()
    }
  }, [searchData])
  




  return (
    <form onSubmit={handleSubmit(onSubmit)}>
      <div className="AdminFastSearchForm">
        <Input
          name="title"
          control={control}
          errors={errors}
          className="admin-input admin-input-2"
          register={{
            required: "  متن اجباری است"
          }}
          placeholder="متن جست و جوی سریع"
          LabelIcon={<img src={search} />}
        />
        <Input
          name="link"
          control={control}
          errors={errors}
          className="admin-input admin-input-2 "
          register={{
            required: "  لینک اجباری است",
            // pattern: {
            //   value:/(http(s)?:\/\/.)?(www\.)?[-a-zA-Z0-9@:%._\+~#=]{2,256}\.[a-z]{2,6}\b([-a-zA-Z0-9@:%_\+.~#?&//=]*)/g,
            //   message:"فرمت لینک اشتباه است"
            // }
          }}
          type='url'
          placeholder="لینک جست و جوی سریع"
          LabelIcon={<img src={link} />}
        />
        <div className="flex  items-center gap-[20px] ">
          <div className=" button red-outline-button">انصراف</div>
          <Button type="submit" varient="primary">
            {!apipostSearch.loading  ? " افزودن ایتم":<BeatLoader
              color="#36d7b7"
              size={10}
              aria-label="Loading Spinner"
              data-testid="loader"
            />}
          </Button>
        </div>
      </div>
    </form>
  );
};

export default AdminFastSearchForm;
